import { FC } from 'react';
import theme from 'config/theme';
import { CurrencyInput } from './CurrencyInput';
import { CandidateType } from '../Candidates/Candidates';
import { CandidateImage } from '../Candidates/CandidateImage';
import { BodySmall, UtilityText } from 'components/Typography';
import { RecipientInputRow } from './styled';
import { formatNumberAsCurrency } from 'helpers/utils';
import { getAmountValidation } from './utils';
import { getContributionLimit } from 'helpers/donate';

interface Props {
  candidate: CandidateType;
  onChangeAmount: (candidate: CandidateType, amount: number, index: number) => void;
  onEditComplete?: () => void;
  showPhoto?: boolean;
  index: number;
}

export const RecipientRow: FC<Props> = ({
  candidate,
  onChangeAmount,
  onEditComplete,
  showPhoto = false,
  index,
}) => {
  const { validationError, validate } = getAmountValidation(candidate);

  const onChange = (value?: number) => {
    onChangeAmount(candidate, value || 0, index);
  };

  if (!candidate.isSelected) {
    return null;
  }

  return (
    <RecipientInputRow $justifyContent="space-between" $alignItems="center">
      <div className="display-flex">
        {showPhoto && <CandidateImage recipientId={candidate.misc_ids?.photo_id} />}
        <div className="display-flex flex-direction-column justify-around">
          <BodySmall $color={validationError && theme.colors.errorRed}>
            {`${candidate.recipient_name} ${
              candidate.race?.election.display_info
                ? `(${candidate.race?.election.display_info})`
                : ''
            }`}
          </BodySmall>
          {(!!getContributionLimit(candidate) || !!validationError) && (
            <div>
              {getContributionLimit(candidate) && (
                <UtilityText
                  $fontType="regular"
                  $color={validationError ? theme.shadows.errorRed(0.7) : theme.shadows.black(0.5)}
                >
                  Contribution limit{' '}
                  {formatNumberAsCurrency(Number(getContributionLimit(candidate)))}
                  {validationError && '. '}
                </UtilityText>
              )}
              {validationError && (
                <UtilityText $color={theme.shadows.errorRed(0.7)}>{validationError}</UtilityText>
              )}
            </div>
          )}
        </div>
      </div>
      <CurrencyInput
        id={`${candidate.recipient_id}-custom-amount-input`}
        validate={validate}
        value={candidate.donationAmount}
        onBlur={onEditComplete}
        onChange={onChange}
      />
    </RecipientInputRow>
  );
};
